import { render } from "./SalesTrainingDetail.vue?vue&type=template&id=7f303c93"
import script from "./SalesTrainingDetail.vue?vue&type=script&lang=js"
export * from "./SalesTrainingDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__